import React, { useEffect, useState } from "react";
import ReBiddingDialog from "../../molecules/ReBiddingDialog";
import Input from "../../atoms/Input";
import Button from "../../atoms/Button";
import { counterBidPostApi } from "../../../utils/API/counterBidPostApi";
import { useDispatch } from "react-redux";
import { LoadingOutlined } from "@ant-design/icons";
import toast from "react-hot-toast";
import { editBids } from "../../../utils/API/editBid";
import { taxationAmount } from "../../../utils/API/taxationAmount";
const ReCounterDialog = ({
  open,
  onOk,
  onCancel,
  selectedRowData,
  selectedColumns,
  bidId,
}) => {
  const dispatch = useDispatch();
  const [noOfCredits, setNoOfCredits] = useState(null);
  const [pricePerCredit, setpricePerCredit] = useState(null);
  const [loading, setLoading] = useState(false);
  const [amount, setAmount] = useState(0);
  const [gst, setGst] = useState(0);
  const [platformFee, setPlatformFee] = useState(0);
  const [remittance, setRemittance] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);

  if (!selectedRowData) {
    return null;
  }
  const previousNoOfCredits = selectedRowData["No. of credits"];
  const previousPricePerCredit = selectedRowData["Bid Price"];

  const handleCounterBid = async () => {
    if (noOfCredits <= 0 || pricePerCredit <= 0) {
      toast.error(
        "Number of Credits and Price Per Credit should be greater than zero."
      );
      return;
    }
    try {
      setLoading(true);
      // const formData = {
      //   bidId: bidId,
      //   counterBidCredits: noOfCredits,
      //   counterBidAmount: pricePerCredit,
      // };
      // const response = await counterBidPostApi(formData, dispatch);
      await editBids(
        bidId,
        {
          noOfCredits: noOfCredits,
          bidAmount: pricePerCredit,
        },
        dispatch
      );

      onOk();
    } catch (error) {
      console.error("Error during counter bid:", error.message);
    } finally {
      setLoading(false);
    }
  };

  // eslint-disable-next-line
  useEffect(() => {
    if (
      noOfCredits &&
      pricePerCredit &&
      noOfCredits !== 0 &&
      pricePerCredit !== 0 &&
      noOfCredits !== "" &&
      pricePerCredit !== ""
    ) {
      fetchTaxationData();
    } else {
      setAmount(0);
      setGst(0);
      setPlatformFee(0);
      setRemittance(0);
      setTotalAmount(0);
    }
  }, [noOfCredits, pricePerCredit]);

  const fetchTaxationData = async () => {
    try {
      const formData = {
        buyerOrigin: "NAT",
        sellerOrigin: "NAT",
        totalAmount: noOfCredits * pricePerCredit,
      };
      const amounts = await taxationAmount(formData, dispatch);
      setAmount(formData.totalAmount);
      setGst(amounts.data.data.tax);
      setPlatformFee(amounts.data.data.platform_fee);
      setRemittance(amounts.data.data.remittance);
      const calculatedTotalAmount =
        formData.totalAmount +
        (amounts.data.data.tax +
          amounts.data.data.platform_fee +
          amounts.data.data.remittance);
      setTotalAmount(calculatedTotalAmount);
    } catch (error) {
      toast.error("Error in Fetching Taxes and amounts Balance");
    } finally {
    }
  };

  return (
    <ReBiddingDialog
      open={open}
      title={"ReBid"}
      onOk={handleCounterBid}
      onCancel={onCancel}
      selectedRowData={selectedRowData}
      selectedColumns={selectedColumns}
    >
      <div className="pt-6">
        {/* Previous Bid Section */}
        <div className="flex pt-2 pr-10 text-base pb-2 gap-x-16">
          <div className="w-40 pl-10 font-bold ">Previous Bid-</div>
          <div className="flex gap-x-32 ">
            <div>No of Credits - {previousNoOfCredits}</div>
            <div>Price per credit - ${previousPricePerCredit}</div>
          </div>
        </div>

        {/* New Bid Section */}
        <div className="flex font-bold pt-2 pr-10 text-base bg-blue-400  ">
          <div className="w-52 pl-10 ">New Bid-</div>
          <div className="flex ml-4 gap-x-20 ">
            <div className="flex">
              <span className="text-base  pr-2 font-bold">No of Credits-</span>
              <Input
                type="number"
                variant="secondary"
                className="inline-block text-base w-14"
                placeHolder={0}
                value={noOfCredits}
                onChange={(e) => {
                  const value = parseInt(e.target.value, 10);
                  if (value > 0) {
                    setNoOfCredits(Math.min(previousNoOfCredits, value));
                  } else {
                    setNoOfCredits(null);
                  }
                }}
              />
            </div>
            <div className="flex">
              <span className="text-base font-bold  pr-2">
                {" "}
                Price per credit -
              </span>
              <Input
                type="number"
                variant="secondary"
                className="inline-block text-base w-14 "
                placeHolder={0}
                value={pricePerCredit}
                onChange={(e) => setpricePerCredit(e.target.value)}
              />
            </div>
          </div>
        </div>

        {/* Calculation Section */}
        <div className=" pl-12 pt-3 text-xs text-gray-400">
          <p className="py-1">Amount = ${amount?.toFixed(2)}</p>
          <p className="pb-1">Taxes(GST) = ${gst?.toFixed(2)}</p>
          <p className="pb-1">Remittance = ${remittance?.toFixed(2)}</p>
          <p className="pb-1">Platform Fee = ${platformFee?.toFixed(2)}</p>
        </div>
        <p className="pl-12 text-sm">Total Fund Required - ${totalAmount}</p>
      </div>

      <div className="flex justify-center gap-5">
        <Button
          varient="primary"
          borderColor="blue"
          className="w-[9.375rem] h-10 mt-4 mb-7 text-base justify-center text-white font-bold border-none bg-blue-800 "
          onClick={() => handleCounterBid()}
        >
          <div className="flex justify-center">
            {loading ? <LoadingOutlined /> : "Re-Bid"}
          </div>
        </Button>
      </div>
    </ReBiddingDialog>
  );
};

export default ReCounterDialog;
